"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbagclock = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 51",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbagclock` : '') + (description ? ` desc-brandedbagclock` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbagclock"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbagclock"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 29.5005V10.5005C36 6.35835 32.6421 3.00049 28.5 3.00049C24.3579 3.00049 21 6.35835 21 10.5005V29.5005C21 33.6426 24.3579 37.0005 28.5 37.0005C32.6421 37.0005 36 33.6426 36 29.5005ZM28.5 0.000488281C22.701 0.000488281 18 4.7015 18 10.5005V29.5005C18 35.2995 22.701 40.0005 28.5 40.0005C34.299 40.0005 39 35.2995 39 29.5005V10.5005C39 4.7015 34.299 0.000488281 28.5 0.000488281Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.9245 13.229C56.0872 12.7046 55.9835 12.1377 55.6464 11.698C55.3084 11.2593 54.7763 11.0005 54.2112 11.0005H1.78883C1.22368 11.0005 0.691629 11.2593 0.353617 11.698C0.0164983 12.1368 -0.0872299 12.7046 0.0755169 13.229L9.40625 47.7672C9.63338 48.4994 10.33 49.0005 11.1196 49.0005H44.4062C45.1958 49.0005 45.8924 48.4994 46.1196 47.7672L55.9245 13.229Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56 39.0005C56 45.6279 50.6274 51.0005 44 51.0005C37.3726 51.0005 32 45.6279 32 39.0005C32 32.3731 37.3726 27.0005 44 27.0005C50.6274 27.0005 56 32.3731 56 39.0005Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_11806_307",
    style: {
      "maskType": "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "34",
    y: "29",
    width: "20",
    height: "21"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M54 39.0004C54 44.5233 49.5228 49.0004 44 49.0004C38.4772 49.0004 34 44.5233 34 39.0004C34 33.4776 38.4772 29.0004 44 29.0004C49.5228 29.0004 54 33.4776 54 39.0004Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_11806_307)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M54 39.0004C54 44.5233 49.5228 49.0004 44 49.0004C38.4772 49.0004 34 44.5233 34 39.0004C34 33.4776 38.4772 29.0004 44 29.0004C49.5228 29.0004 54 33.4776 54 39.0004Z",
    fill: "#DAFCFE"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 40.8338C44.4602 40.8338 44.8333 40.4607 44.8333 40.0005C44.8333 39.5403 44.4602 39.1672 44 39.1672C43.5398 39.1672 43.1667 39.5403 43.1667 40.0005C43.1667 40.4607 43.5398 40.8338 44 40.8338ZM44 42.0005C45.1046 42.0005 46 41.1051 46 40.0005C46 38.8959 45.1046 38.0005 44 38.0005C42.8954 38.0005 42 38.8959 42 40.0005C42 41.1051 42.8954 42.0005 44 42.0005Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 33.0187V40.0005H43V33.0187C43 32.4563 43.4477 32.0005 44 32.0005C44.5523 32.0005 45 32.4563 45 33.0187Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 40.0005C43 39.4482 43.4668 39.0005 44.0426 39.0005H48.9574C49.5332 39.0005 50 39.4482 50 40.0005C50 40.5528 49.5332 41.0005 48.9574 41.0005H44.0426C43.4668 41.0005 43 40.5528 43 40.0005Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.0271129 13.0005L8.73554 45.1005C20.9937 38.2542 32.4912 31.0906 47.9975 11.0005L2.03556 11.0005C0.344069 10.9566 -0.0447683 12.2969 0.0271129 13.0005Z",
    fill: "#F8985A"
  }));
};
var _default = exports.default = brandedbagclock;